// extracted by mini-css-extract-plugin
export default {"list":"styles_list__6mVoX","listButton":"styles_listButton__STfUh"};